import { Component, inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { OwnerShipTypesService } from "../../../../../services/owner-ship-types.service";
import { BasicEditForm } from "@shared/form/basic/basic-edit.form";
import {
  EFormFieldTypes,
  IFormFields,
} from "@shared/form/basic/basic-form.interface";
import { CabButtonComponent } from "@shared/form/components/cab-button/cab-button.component";
import { CabInputComponent } from "@shared/form/components/cab-input/cab-input.component";
import { CabTabComponent } from "@shared/cab-tab/cab-tab.component";
import { CabLoadingComponent } from "@shared/cab-loading/cab-loading.component";

@Component({
  selector: "app-edit-owner-ship-types-form",
  templateUrl: "../owner-ship-types-form.component.html",
  styleUrls: ["./edit-owner-ship-types-form.component.scss"],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CabTabComponent,
    CabInputComponent,
    CabButtonComponent,
    CabLoadingComponent,
  ],
})
export class EditOwnerShipTypesFormComponent extends BasicEditForm {
  _defaultService = inject(OwnerShipTypesService);
  formFields: IFormFields = {
    id: this.createFormField(0),
    name: this.createFormField(
      "",
      [Validators.required, Validators.minLength(3)],
      EFormFieldTypes.TRANSLATE
    ),
    shortName: this.createFormField(
      "",
      [Validators.required, Validators.minLength(3)],
      EFormFieldTypes.TRANSLATE
    ),
  };

  constructor() {
    super();
  }
}
